<template>
  <b-modal
    id="select-category"
    :modal-class="modalClasses"
    :hide-footer="true"
    ref="selectCategory"
    @shown="shown"
    @hidden="hidden"
  >
    <template v-slot:modal-title>
      Selecione ou crie <br/>uma categoria
    </template>

    <template v-slot:default>
      <AlertWraper
        :content="errors"
        type="error"
      />
      <div v-if="!loading">
        <ul>
          <li
            v-for="category in categories"
            :key="category.id"
          >
            <div
              class="d-flex align-items-center item rounded-regular p-2"
              @click="selectCategory(category)"
            >
              <div
                class="image rounded-regular background-cover"
                :style="{ backgroundImage: `url('${category.cover}')` }"
              ></div>
              <div class="content pl-2 d-flex align-items-center">
                <span class="font-size-small">{{ category.name }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <Loader
        class="mb-3"
        color="color2"
        size="big"
        v-else
      />
      <div
        v-if="createForm"
      >
        <form
          action=""
          method="POST"
          @submit.prevent="create"
        >
          <div class="form-group">
            <input
              type="text"
              class="form-control bordered-bottom w-100 text-left font-size-small"
              v-model="$v.category.name.$model"
              placeholder="Nome"
            />
          </div>
          <div class="text-center">
            <Button
              type="submit"
              class="btn-primary btn-sm"
              :loading="creating"
              :disabled="$v.$invalid"
            >
              Criar
            </Button>
          </div>
        </form>
      </div>
      <div
        class="text-center"
        v-else
      >
        <Button
          class="btn-outline-color2 btn-sm"
          @click="createForm = !createForm"
        >
          Criar nova categoria
        </Button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { mapState } from 'vuex'
import CategoriesService from '@/modules/categories/services/categories-service'
import { parseErrorResponseToArray } from '@/utils'
import { required } from 'vuelidate/lib/validators'

import AlertWraper from '@/components/common/Alert/AlertWraper.vue'
import Button from '@/components/common/Button/Button.vue'
import Loader from '@/components/common/Loader/Loader.vue'

export default {
  name: 'SelectCategoryModal',
  props: [],
  components: {
    AlertWraper,
    Button,
    Loader
  },
  data () {
    return {
      categories: [],
      createForm: false,
      errors: null,
      creating: false,
      loading: false,
      category: {
        name: ''
      },
      page: 1
    }
  },
  validations () {
    return {
      category: {
        name: { required }
      }
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    modalClasses () {
      return {
        'default-modal': true,
        'modal-small': true
      }
    }
  },
  methods: {
    shown () {
      this.reset()
      this.getCategories()
    },
    hidden () {
      this.reset()
    },
    reset () {
      this.createForm = false
      this.categories = []
      this.errors = null
    },
    async getCategories () {
      this.loading = true
      try {
        const categories = await CategoriesService.getCategories({})
        this.categories = [...this.categories, ...categories]
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loading = false
    },
    async create () {
      this.creating = true
      try {
        const newCategory = await CategoriesService.postCategory(null, this.category)
        this.categories.push(newCategory)
        this.category.name = ''
        this.createForm = false
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.creating = false
    },
    selectCategory (category) {
      this.$emit('category-selected', category.id)
      this.$bvModal.hide('select-category')
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  transition: all 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: $color6;
  }
}
.image {
  width: 60px;
  height: 40px;
}
.content {
  flex-grow: 1;
}
</style>
